import React		from 'react'
import Axios 		from 'axios'
import NumberFormat from 'react-number-format'
import {marks as marcas,
	colors as cores,
	myServer} from './constants'
	
Axios.defaults.withCredentials = true

//>>>>> Goggle Analytics <<<<<
export const gaSendEvent = (category, label, value) => {
	try{ window.ga('send', 'event', category, label, value) }catch(e){}
}
export const gaPageview = () => {
	try{ window.ga('send', 'pageview'); }catch(e){}
}

//>>>>> MODIFICANDO O CABEÇALHO <<<<<<
export function appendScript(url, callback=()=>{}){
	let script  = document.createElement('script')
	script.charset  = "utf-8" 
	script.src  = url
	script.onload = callback
	document.querySelector('body').appendChild(script)
  }
  
  export function appendMetaTagName(name, content){
	let meta    = document.createElement('meta')
	meta.name   = name
	meta.content= content
	document.querySelector('head').appendChild(meta)
  }

  export function appendMetaTagProperty(property, content){
	let meta    = document.createElement('meta')
	meta.setAttribute('property',property)
	meta.content= content
	document.querySelector('head').appendChild(meta)
  }
  
  export function appendLinkTag(rel, href){
	let link    = document.createElement('link')
	link.rel    = rel
	link.href   = href
	if(rel==="alternate")
		link["hreflang"]="pt-br"

	document.querySelector('head').appendChild(link)
  }

//>>>>> GERAR CONDIÇÃO DE BUSCA PARA TEXTO <<<<<
	export function getSearchCondition(txt) {
		let d=new Date().getFullYear()+1, anos=[], prc=[], crs=[],
            mrcs="", foto="", sts='"status":"ativo"', mod="", mar="", km="", //bsc=txt,
            ano="", pre="", cor="", loc="", cid="", dist="", promo="", comp="", w;
                
            txt=txt.toLowerCase().replace(/citroen/gi,'citroën')
            if(txt.indexOf("com foto")>-1){
                foto=',"foto.capa":{"$nin":[""]}'
                txt=txt.replace(/(com\sfotos|com\sfoto)/g,'')
            }
            if(txt.indexOf("promo")>-1){
                txt=txt.replace(/(em\spromocao|em\spromoçao|em\spromocão|em\spromoção|promocao|promoçao|promocão|promoção|promocoes|promoçoes|promocões|promoções)/g,'')
                if(txt.indexOf("promo")<0) promo=',"$and":[{"promo":{"$exists":true}}, {"promo":{"$nin":[0,"0"]}}]'
            }
            if(txt.indexOf("km")>-1){
                txt=txt.replace(/(zero\skm|0 km|0km)/g,'')
                if(txt.indexOf("km")<0) km=',"zero":true'
                else{
                    txt=txt.replace(/(com km|km)/g,'')
                    if(txt.indexOf("km")<0) km=',"km":{"$ne":"0 km"}'
                }
            }
            if(txt.indexOf("completo")>-1){
                txt=txt.replace(/completo/g,'')
                comp=',"acess":{"$all":["Ar ","Direção ","Travas ","Vidros "]}'
            }
            
            w=txt.replace(/\s\s/g,' ').split(" ")
            txt=""
            w.forEach(function(p){
                var n=p.replace(/(\.|\$)/g,"").replace(",",".")
                if(isNumeric(p) && p*1>1900 && p*1<=d) anos.push(p*1)
                else if(marcas.indexOf(p)>-1) mrcs+=p+' '
                else if(cores.indexOf(p)>-1) crs.push(p.substr(0,p.length-1))
                else if(p.substr(0,1)==="$" && isNumeric(n)) prc.push(n*1)
                else if(isNumeric(n) && n*1>89 && n*1<100) anos.push(n*1+1900)
                else if(p.length===3 && p.substr(1,1)==="." && isNumeric(n)) txt+=p+' '
                else if(isNumeric(n) && n*1>0) prc.push(n*1)
                else if(p.length) txt+=p+' '
            })
            txt=txt.trim(); mrcs=mrcs.trim(); 
            anos.sort()
            
            if(crs.length){
                cor=', "cor":{"$in":['
                crs.forEach(function(c){ cor+='"'+c+'",'})
                cor=cor.substr(0,cor.length-1)+']}'
            }
            if(prc.length){
                if(prc.length===1){
					prc.push(prc[0]-2500>0 ? prc[0]-2500 : 1)
					prc.push(prc[0]+2500)
				} 
                prc.sort()
                pre=',"preco":{"$gte":'+prc[0]+',"$lte":'+prc[prc.length-1]+'}'
            }
            if(txt.length)
                mod=',"desc":{"$in":["'+txt.replace(/\s\s/g,' ').replace(/\s/g,'.*')+'"]}'
            if(mrcs.length)
                mar=',"marca":{"$in":["'+mrcs.replace(/\s\s/g,' ').replace(/\s/g,'","')+'"]}'
            if(anos.length)
                ano=',"ano":{ "$gte": "'+anos[0]+'", "$lte": "'+(anos[anos.length-1]*1+1)+'"}'
            //if(pos!="") loc='"coords":{"$nearSphere":{"$geometry":{"type":"Point","coordinates":['+lonU+','+latU+'] },"maxDistance":1000000}},'
            
            //preenchendo filtro de distância
            /*try{val=$("#dist .slider").slider("value")*1}catch(e){val=8}
            if(val>0 && val<8){
                switch(val){
                    case 7: cid=',"cidade":{"$regex": "('+regiao[citySEL.siglas[1]]+')$"}';break;
                    case 6: cid=',"cidade":{"$regex": "('+citySEL.siglas[0]+')$"}';break;
                    case 5: case 4: case 3: case 2: case 1:
                        var r=raio[val-1].replace("km","")*1000
                        pos=getCookie("pos")
                        if(pos!=""){
                            pos=getMat(JSON.parse('['+pos+']'))
                            dist=',"coords":{"$near":{"$geometry":{"type":"Point","coordinates":['+pos[1]+','+pos[0]+'] },"$maxDistance":'+r+'}}'
                        }
                }
            }*/
            return '{'+loc+sts+cid+dist+mod+mar+ano+pre+cor+foto+promo+km+comp+'}'
	}

//>>>>> FORMATAÇÃO DE DADOS <<<<<
	export const parseXmlToJson = (txt) => {
		const obj = xmlToJson((new DOMParser()).parseFromString(txt, "application/xml"))
		return obj["soap:Envelope"] && obj["soap:Envelope"]["soap:Body"] ? obj["soap:Envelope"]["soap:Body"] : obj;
	}
	
	export const xmlToJson = (xml) => {
	
		// Create the return object
		var obj = {};
	
		if (xml.nodeType === 1) { // element
			// do attributes
			// if (xml.attributes.length > 0) {
			// 	obj["@attributes"] = {};
			// 	for (var j = 0; j < xml.attributes.length; j++) {
			// 		var attribute = xml.attributes.item(j);
			// 		obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
			// 	}
			// }
		} else if (xml.nodeType === 3) { // text
			obj = xml.nodeValue;
		}

		// do children
		if (xml.hasChildNodes()) {
			for(var i = 0; i < xml.childNodes.length; i++) {
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;
				//if(nodeName==="#text") console.log(nodeName.substr(0,1))
				if (typeof(obj[nodeName]) === "undefined") {
					if(nodeName.substr(0,1)==="#") obj=xmlToJson(item)
					else obj[nodeName] = xmlToJson(item);
				} else {
					if (typeof(obj[nodeName].push) === "undefined") {
						var old = obj[nodeName];
						obj[nodeName] = [];
						obj[nodeName].push(old);
					}
					// console.log(xmlToJson(item))

					obj[nodeName].push(xmlToJson(item));
				}
			}
		}

		return obj
	};
	//FORMATAÇÃO DE NÚMERO EM TEXTO 
	export const buildTextFormat = (value, format, prefix="", sufix="") => {
		return (
			<>
				<NumberFormat 
					value           ={value}
					format          ={format}
					suffix          ={sufix}
					prefix          ={prefix}
					displayType		={'text'}
				/>
			</>
		)
	}

	//>>>> FORMATAÇÃO DE DATA
	export function formatDateDMY(date, separator="/", monthName=false) { 
		const monthNames = [
		  "jan", "fev", "mar",
		  "abr", "mai", "jun",
		  "jul", "ago", "set",
		  "out", "nov", "dez"
		];
	   
		if(date instanceof Date && !isNaN(date.valueOf())){
			const day	= ("0"+date.getDate()).substr(-2);
			const month	= monthName? monthNames[date.getMonth()] : ("0"+(date.getMonth()+1)).substr(-2);
			const year	= date.getFullYear();
		
			return day + separator + month + separator + year;
		}else return "-"
	}
	
	//CONVERTE ID MONGO EM DATA
	export function dateFromObjectId(objectId) {
		return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
	}
//----- FIM - FORMATAÇÃO DE DADOS -----

//>>>>> VALIDAÇÃO DE DADOS <<<<<
	//VERIFICA SE UM TELEFONE É VÁLIDO
	export function isValidPhone(fone){
		const f=fone.replace(/\(|\)|\s|-/g,''), re =/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/; return re.test(f) && f.length>=10 }

	//VERIFICA SE UM E-MAIL É VÁLIDO
	export	function isValidEmail(email){
		const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+(?:[A-Z]{2}|com|club|org|net|gov|mil|biz|info|mobi|name|aero|jobs|museum)\b/i;
		return re.test(email);
	}
//----- FIM - VALIDAÇÃO DE DADOS -----

//>>>>> IP FUNCTIONS <<<<<
	export function getIp(callback){
		function response(s){
			callback(window.userip);
			s.onload = s.onerror = null;
			document.body.removeChild(s);
		}

		function trigger(){
			window.userip = false;
			var s = document.createElement("script");
			s.async = true;
			s.onload = function(){ response(s) };
			s.onerror = function(){ response(s) };

			s.src = "https://l2.io/ip.js?var=userip";
			document.body.appendChild(s);
		}

		if (/^(interactive|complete)$/i.test(document.readyState)){ trigger() }
		else{document.addEventListener('DOMContentLoaded', trigger);}
	}
//----- FIM - IP FUNCTIONS -----

//>>>>> OUTRAS FUNÇÕES <<<<<
	//RETORNA  LETRAS INICIAIS PARA UM TEXTO
	export const getInitials = txt => {
		const words = txt.trim().replace(/\s\s/g,' ').split(" ")
		
		if(words.length>1)
			return (words[0].substr(0,1)+words[1].substr(0,1)).toUpperCase()

		return txt.toUpperCase().substr(0,1)
	}

	//REMOVE ACENTOS DE TEXTO
	export function semAcentos(s){var sa="áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ",ss="aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC",n="";for (var i = 0; i < s.length; i++){if(sa.indexOf(s.charAt(i))!==-1){n+=ss.substr(sa.search(s.substr(i,1)),1)}else{n+=s.substr(i, 1)}}return n}

	//VERIFICA SE O DISPOSIVO É UM CELULAR
	export const isMobile = function() {var check = false;(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);return check;}

	//RETIRA TODOS OS CARACTERES NÃO NUMÉRICOS
	export const onlyNumbers = (txt) => txt.replace(/(?![0-9])./g,"")

	//verifica se um texto é apenas nu
	export const isNumeric = (txt) => {
		let result = false
		try{ txt = txt * 1; result = true }catch(e){}
		return result
	} 
	//DESCOMPRIME DADOS
	export function getMat(e){var t=window.lzwCompress;return t.unpack(e)}
	//COMPRIME DADOS
	export function setMat(e){var t=window.lzwCompress;return t.pack(e)}

	//ARMAZENA DADOS EM COOKIES
	export function setCookie(e,t,n){var r=new Date();r.setTime(r.getTime()+24*n*60*60*1e3);var i="expires="+r.toUTCString();document.cookie=e+"="+t+"; "+i+";path=/"}
	//LER DADOS DE COOKIES
	export function getCookie(e){for(var t=e+"=",n=document.cookie.split(";"),r=0;r<n.length;r++){for(var i=n[r];" "===i.charAt(0);)i=i.substring(1);if(0===i.indexOf(t))return i.substring(t.length,i.length)}return""}
	
	export const getDescSplit = (txt) => {
		let desc = txt ? txt.trim().replace(/<\//g,'<').replace(/<v>/gi,"&nbsp;") : ""
		return desc.split("&nbsp;")
	}

	export const getNumberFormat = (value) => (<NumberFormat value={value} displayType="text" decimalSeparator="," thousandSeparator="." />)

	//retorna caracteres em html para condificação do tipo &amp;
	export const parserTxtToHtml = (txt) => {
		try{
			return (new DOMParser()).parseFromString(txt,'text/html').body.textContent;
		}catch(e){}
		return txt
	}

	export const putBR = (txt) => {
		let   desc = parserTxtToHtml(txt).split(/\n/g),
			result = desc.map((d, i) => <span key={i}>{d}<br/></span>);
	
		return <>{result}</>
	}
	
//----- FIM - OUTRAS FUNÇÕES -----

const getCilindrada = txt =>{
	const re = /[0-9]\.[0-9]/gi,
		wrds = txt.trim().split(" ")
	let res = ""
	wrds.every(e =>{
		if(re.test(e)){
			res = e
			return false
		}
		return true
	})
	return res
}
const filterArray = (list, field, value, equal=false) =>{
	let txt = cleanText(semAcentos(value)).trim().toLowerCase(),
		res = equal 
			? list.filter(m=> cleanText(semAcentos(m[field])).toLowerCase()===txt)
			: list.filter(m=> cleanText(semAcentos(m[field])).toLowerCase().indexOf(txt)===0);
	
	return res
}

export const cleanText = txt => {
	const re = /-|!/g
	return txt.replace(re,'')
}
//----- INTEGRAÇÃO - WEBMOTORS -----
export const webmotors = {
	autenticar: async (cnpj, email, senha) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/autenticar`,{cnpj, email, senha}),
			xml = data && data.xml && data.xml.indexOf("HashAutenticacao")>0 ? parseXmlToJson(data.xml) : {},
			hash= xml["autenticarResponse"] && xml["autenticarResponse"]["autenticarResult"] 
					? xml["autenticarResponse"]["autenticarResult"]["HashAutenticacao"]
					: [];
		return hash 
	},
	marcas: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/marcas`,{hash}),
			xml = data && data.xml && data.xml.indexOf("MarcaWM")>0 ? parseXmlToJson(data.xml) : {},
			marcas= xml["ObterMarcaResponse"] && xml["ObterMarcaResponse"]["ObterMarcaResult"] 
					? xml["ObterMarcaResponse"]["ObterMarcaResult"]["MarcaWM"]
					: [];
		return marcas 
	},
	modelos: async (hash, code) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/modelos`,{hash, code}),
			xml = data && data.xml && data.xml.indexOf("ModeloWM")>0 ? parseXmlToJson(data.xml) : {},
			modelos= xml["ObterModeloResponse"] && xml["ObterModeloResponse"]["ObterModeloResult"] 
					? xml["ObterModeloResponse"]["ObterModeloResult"]["ModeloWM"]
					: [];
		return modelos 
	},
	versoes: async (hash, code, year) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/versoes`,{hash, code, year}),
			xml = data && data.xml && data.xml.indexOf("Versao")>0 ? parseXmlToJson(data.xml) : {},
			modelos= xml["ObterVersaoResponse"] && xml["ObterVersaoResponse"]["ObterVersaoResult"] 
					? xml["ObterVersaoResponse"]["ObterVersaoResult"]["Versao"]
					: [];
		return modelos 
	},
	modalidades: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/modalidades`,{hash}),
			xml = data && data.xml && data.xml.indexOf("ModalidadeWM")>0 ? parseXmlToJson(data.xml) : {},
			modalidades= xml["ObterModalidadeResponse"] && xml["ObterModalidadeResponse"]["ObterModalidadeResult"] 
					? xml["ObterModalidadeResponse"]["ObterModalidadeResult"]["ModalidadeWM"]
					: [];
		return modalidades 
	},
	cambios: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/cambios`,{hash}),
			xml = data && data.xml && data.xml.indexOf("TipoCambioWM")>0 ? parseXmlToJson(data.xml) : {},
			cambios= xml["ObterCambioResponse"] && xml["ObterCambioResponse"]["ObterCambioResult"] 
					? xml["ObterCambioResponse"]["ObterCambioResult"]["TipoCambioWM"]
					: [];
		return cambios 
	},
	combustiveis: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/combustiveis`,{hash}),
			xml = data && data.xml && data.xml.indexOf("CombustivelWM")>0 ? parseXmlToJson(data.xml) : {},
			combustiveis= xml["ObterCombustivelResponse"] && xml["ObterCombustivelResponse"]["ObterCombustivelResult"] 
					? xml["ObterCombustivelResponse"]["ObterCombustivelResult"]["CombustivelWM"]
					: [];
		return combustiveis 
	},
	cores: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/cores`,{hash}),
			xml = data && data.xml && data.xml.indexOf("CorWM")>0 ? parseXmlToJson(data.xml) : {},
			cores= xml["ObterCoresResponse"] && xml["ObterCoresResponse"]["ObterCoresResult"] 
					? xml["ObterCoresResponse"]["ObterCoresResult"]["CorWM"]
					: [];
		return cores 
	},
	portas: async (hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/portas`,{hash}),
			xml = data && data.xml && data.xml.indexOf("NumeroPortasWM")>0 ? parseXmlToJson(data.xml) : {},
			portas= xml["ObterNumeroPortasResponse"] && xml["ObterNumeroPortasResponse"]["ObterNumeroPortasResult"] 
					? xml["ObterNumeroPortasResponse"]["ObterNumeroPortasResult"]["NumeroPortasWM"]
					: [];
		return portas 
	},
	inserir: async (xml,hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/inserir`,{xml, hash}),
			xml1 = data && data.xml && data.xml.indexOf("CodigoAnuncio")>0 ? parseXmlToJson(data.xml) : {},
			codigo = xml1["IncluirCarroResponse"] && xml1["IncluirCarroResponse"]["IncluirCarroResult"] 
					? xml1["IncluirCarroResponse"]["IncluirCarroResult"]["CodigoAnuncio"]
					: [];
			//codigo && console.log("Retorno" ,xml1["IncluirCarroResponse"]["IncluirCarroResult"]["CodigoRetorno"])
		return codigo 
	},
	excluir: async (code,hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/excluir`,{code, hash}),
			xml = data && data.xml && data.xml.indexOf("CodigoAnuncio")>0 ? parseXmlToJson(data.xml) : {},
			codigo = xml["ExcluirCarroResponse"] && xml["ExcluirCarroResponse"]["ExcluirCarroResult"] 
					? xml["ExcluirCarroResponse"]["ExcluirCarroResult"]["CodigoAnuncio"]
					: [];
		return codigo 
	},
	inserirFoto: async (code, foto, hash) => {
		const {data} = await Axios.post(`${myServer}/integrador/webmotors/foto-inserir`,{code, foto, hash}),
			xml = data && data.xml && data.xml.indexOf("CodigoRetorno")>0 ? parseXmlToJson(data.xml) : {},
			obj = xml["IncluirFotoResponse"] && xml["IncluirFotoResponse"]["IncluirFotoResult"] 
					? xml["IncluirFotoResponse"]["IncluirFotoResult"]
					: null;

		return obj 
	},
	getPorta: async (text, hash) => {
		text = text+""
		const portas = await webmotors.portas(hash),
			porta = portas.filter(e => e.Descricao===text)
		if(porta.length)
			return porta[0]
		return {CodigoPortas: "2", Descricao: "2"}
	},
	getCor: async (text, hash) => {
		text = semAcentos(text).trim().toLowerCase()
		text = text.substr(0, text.length-1)
		const cores = await webmotors.cores(hash),
			cor = cores.filter(e => semAcentos(e.Descricao).toLowerCase().indexOf(text)>-1)

		if(cor.length)
			return cor[0]
		return {CodigoCor: "30404", Descricao: "Branco"}
	},
	getCombustivel: async (text, hash) => {
		text = semAcentos(text).trim().toLowerCase().replace(/\//g,'')
		const combustiveis = await webmotors.combustiveis(hash),
			combustivel = combustiveis.filter(e => semAcentos(e.Descricao.replace(/\se\s|,\s/g,'')).toLowerCase().indexOf(text)>-1)
		
		if(combustivel.length)
			return combustivel[0]
		return {Descricao: "Gasolina", CodigoCombustivel: "21201"}
	},
	getCambio: async (text, hash) => {
		text = semAcentos(text).trim().toLowerCase()
		text = text.substr(0, text.length-1)
		const cambios = await webmotors.cambios(hash),
			cambio = cambios.filter(e => semAcentos(e.Descricao).toLowerCase().replace(/-/g,'').indexOf(text)>-1)
			
		if(cambio.length)
			return cambio[0]
		return {CodigoCambio: "23001", Descricao: "Manual"}
	},
	getModalidade: async (hash) => {
		const modalidade = await webmotors.modalidades(hash)
		if(modalidade.length){
			modalidade.length>1 && modalidade.sort((a,b) => {
				const ta= a.QuantidadeAnunciosTotal*1 - a.QuantidadeAnuncios*1,
					tb = b.QuantidadeAnunciosTotal*1 - b.QuantidadeAnuncios*1;
					
				if(ta>tb) return -1
				else if(ta<tb) return 1
				else return 0
			})
			//console.log(modalidade) 
			return modalidade[0]
		}
		return null
	},
	getModeloVersao: async (tMarca, tModelo, tAno, tVersao, hash) => { 
		//DETERMINANDO A MARCA
		let result = {marca:{}, modelo:{}, versao:{}},
			marcas  = await webmotors.marcas(hash),
			marca   = filterArray(marcas,"NomeMarca", tMarca);
        if(marca.length===0){
			marca   = filterArray(marcas, "NomeMarca", tMarca.substr(0,3))
        }
        if(marca.length){
            if(marca.length===1) marca=marca[0]
            else{
                console.log("várias marcas selecionadas",tMarca, marcas)
            }

            if(marca["CodigoMarca"]){ //DETERMINANDO O MODELO
				//console.log("Marca",  marca)
				result.marca = marca
                const modelos = await webmotors.modelos(hash, marca["CodigoMarca"])
                if(modelos.length){ 
                    const model = tModelo.trim().split(" ")[0];
					let modelo= filterArray(modelos, "NomeModelo", model)

                    //console.log(modelo, model, modelos)
                    if(modelo.length===1) modelo=modelo[0]
                    else{
                        modelo = modelo.length ? filterArray(modelo, "NomeModelo", tModelo) : []
						
						//console.log(modelo,tModelo, modelos)
                        if(modelo.length===1) modelo=modelo[0]
                        else{
							modelo = modelo.length ? filterArray(modelos, "NomeModelo", tModelo, true) : []
							//console.log(modelo,tModelo, modelos)
                            if(modelo.length===1) modelo=modelo[0]
                            else{
								modelo= filterArray(modelos, "NomeModelo", model, true)
								if(modelo.length===1) modelo=modelo[0]
								else
                                	console.log("MODELO NÃO DETERMINADO", tModelo, modelos)
							}
                        }
                    }

                    if(modelo["CodigoModelo"]){ //DETERMINANDO O ANO DO MODELO
						result.modelo = modelo
						const mdl = tModelo.trim()+' '+tVersao.trim(),
								vrs = semAcentos(mdl).toUpperCase().split(" "),
								cil = getCilindrada(mdl),
								field = "NomeVersao", 
							year = (new Date()).getFullYear();
						let versoes = [];
						for(let i=tAno-1;i<=year;i++){
							const resp = await webmotors.versoes(hash, modelo["CodigoModelo"], i)
							//console.log("cil", cil,"Resp"+i,resp)
							if(cil.length){
								if(resp && resp.length)
								 versoes=versoes.concat(resp.filter(v => {
									let resp = false
									if(v[field].indexOf(cil)>-1){
										if(Array.isArray(v["AnoModelo"]["AnoModeloWM"])){
											v["AnoModelo"]["AnoModeloWM"].every(a => {
												if(a["AnoModelo"]===tAno){ 
													resp=true
													return false
												}
												return true
											})
										}else if(v["AnoModelo"] && v["AnoModelo"]["AnoModeloWM"] && v["AnoModelo"]["AnoModeloWM"]["AnoModelo"]){
											resp = v["AnoModelo"]["AnoModeloWM"]["AnoModelo"]===tAno
										}
									}
									return resp
								}))
							}else if(resp && resp.length) 
							 versoes=versoes.concat(resp.filter(v => {
								let resp = false
								if(Array.isArray(v["AnoModelo"]["AnoModeloWM"])){
									v["AnoModelo"]["AnoModeloWM"].every(a => {
										if(a["AnoModelo"]===tAno){
											//console.log(v["NomeVersao"],a["AnoModelo"])
											resp=true
											return false
										}
										return true
									})
								}else if(v["AnoModelo"] && v["AnoModelo"]["AnoModeloWM"] && v["AnoModelo"]["AnoModeloWM"]["AnoModelo"]){
									resp = v["AnoModelo"]["AnoModeloWM"]["AnoModelo"]===tAno
								}
								return resp
							}))
						}
                            
						if(versoes.length>1){ 
							//console.log("Cilindrada",cil)
							versoes.forEach(v => {
								let ttl = 0,
									name = semAcentos(v[field]);
								vrs.forEach(e => {
									if(name.indexOf(e)>-1) ttl+=e.length // && name.indexOf(cil)>-1
								})
								v["total"]=ttl
							})
							versoes.sort((a,b)=>{
								if(a.total>b.total){ return -1 }
								else if(a.total<b.total){ return 1 }
								else{
									if(a[field].length<b[field].length){return -1}
									else if(a[field].length>b[field].length){return 1}
									else return 0
								}
							})
							//console.log(versoes[0],versoes)
							result.versao = versoes[0]
						}else{
							if(versoes[0])	result.versao = versoes[0]
							else			result.versao = versoes
							//console.log(versoes)
						}
                    }
                }
            }
		}else console.log("Nenhuma marca selecionadas", tMarca, marcas)
		return result
	},
	getAd: async (data, hash) => {
		let desc = data.desc.replace("</v","<v").split("<v>"),
			anos = data.ano.split("/").sort(),
			anomod = anos.pop(),
			versao = (desc[1] ? desc[1] : "") + (data.cambio ? " "+data.cambio.substr(0,3) : "");
			
		const modeloVersaoWM = await webmotors.getModeloVersao(data.marca, desc[0], anomod, versao, hash),
			modalidade = await webmotors.getModalidade(hash),
			cambio = await webmotors.getCambio(data.cambio, hash),
			cor = await webmotors.getCor(data.cor, hash),
			porta = await webmotors.getPorta(data.portas, hash),
			combustivel = await webmotors.getCombustivel(data.combustivel, hash);

		console.log("modeloVersaoWM",modeloVersaoWM)
		
		let json = {}
		//json["CodigoAnuncio"]= ""
		json["CodigoModalidade"]=modalidade.CodigoModalidade
		json["TipoAnuncio"]= modalidade.TipoAnuncio
		json["CodigoMarca"] = modeloVersaoWM.marca.CodigoMarca
		json["CodigoModelo"]= modeloVersaoWM.modelo.CodigoModelo
		json["CodigoVersao"]= modeloVersaoWM.versao.CodigoVersao
		json["AnoDoModelo"] = anomod
		json["AnoFabricacao"]=anos[0]
		json["Km"]= data.km.trim().replace(/\skm|\./gi,'')
		json["Placa"]= data.placa.replace(/-/g,'')
		json["NrPortas"]=porta.CodigoPortas
		json["CodigoCambio"]=cambio.CodigoCambio
		json["CodigoCor"]=cor.CodigoCor
		json["CodigoCombustivel"]=combustivel.CodigoCombustivel
		// json["DescricaoCambio"]=`<![CDATA[${cambio.Descricao}]]>`
		// json["DescricaoCor"]=`<![CDATA[${cor.Descricao}]]>`
		// json["DescricaoCombustivel"]=`<![CDATA[${combustivel.Descricao}]]>`
		json["Blindado"]=data.neces.indexOf("Blindado")>-1 ? "S" : "N"
		json["AdaptadoDeficientesFisicos"]=data.neces.indexOf("Adaptado para deficientes físicos")>-1 ? "S" : "N"
		json["UnicoDono"]=data.docs.indexOf("Único dono")>-1 ? "S" : "N"
		json["Alienado"]=data.docs.indexOf("Alienado")>-1 ? "S" : "N"
		json["IpvaPago"]=data.docs.indexOf("IPVA pago")>-1 ? "S" : "N"
		json["NaoAceitaTroca"]="N"
		json["RevisadoOficinaAgendaDoCarro"]=data.docs.indexOf("Todas revisões pela agenda do carro")>-1 ? "S" : "N"
		json["RevisoesEmConcessionaria"]=data.docs.indexOf("Todas revisões pela concessionária")>-1 ? "S" : "N"
		json["GarantiaDeFabrica"]=data.docs.indexOf("Garantia de fábrica")>-1 ? "S" : "N"
		json["Licenciado"]=data.docs.indexOf("Licenciado")>-1 ? "S" : "N"
		json["PrecoReal"]=`${data.preco+1}`
		json["PrecoVenda"]=`${data.preco}`
		//json["Observacao"]=`<![CDATA[${data.obs}]]>`
		// json["DataInclusao"]=''
		// json["DataUltimaAlteracao"]=""
		//json["Opcional"]="<OpcionalWM><CodigoOpcional>1</CodigoOpcional>"
		//json["CodigoRetorno"]=""
		return json
	}
}
//----- INTEGRAÇÃO - ICARROS -----
export const icarros = {
	autenticar: async () => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/autenticar`,{}),
			xml = data && data.xml && data.xml.indexOf("autenticarAcesso")>0 ? parseXmlToJson(data.xml) : {},
			token= xml["ns1:autenticarAcessoResponse"] && xml["ns1:autenticarAcessoResponse"]["return"] 
					? xml["ns1:autenticarAcessoResponse"]["return"]
					: "";
		return token 
	}, 
	marcas: async (token) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/marcas`,{token}),
			xml = data && data.xml && data.xml.indexOf("obterMarcas")>0 ? parseXmlToJson(data.xml) : {},
			marcas= xml["ns1:obterMarcasResponse"] && xml["ns1:obterMarcasResponse"]["return"] 
					? xml["ns1:obterMarcasResponse"]["return"]["dados"]
					: [];
			//id is the Key
			console.log(xml)
		return marcas 
	}, 
	modelos: async (token, code) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/modelos`,{token, code}),
			xml = data && data.xml && data.xml.indexOf("obterModelos")>0 ? parseXmlToJson(data.xml) : {},
			modelos= xml["ns1:obterModelosResponse"] && xml["ns1:obterModelosResponse"]["return"] 
					? xml["ns1:obterModelosResponse"]["return"]["modelos"]
					: [];
			console.log(xml)
		return modelos 
	}, 
	versoes: async (token, code) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/versoes`,{token, code}),
			xml = data && data.xml && data.xml.indexOf("obterVersoes")>0 ? parseXmlToJson(data.xml) : {},
			versoes= xml["ns1:obterVersoesResponse"] && xml["ns1:obterVersoesResponse"]["return"] 
					? xml["ns1:obterVersoesResponse"]["return"]["versoes"]
					: [];
			console.log(xml)
		return versoes 
	}, 
	combustiveis: async (token) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/combustiveis`,{token}),
			xml = data && data.xml && data.xml.indexOf("obterCombustivel")>0 ? parseXmlToJson(data.xml) : {},
			combustiveis= xml["ns1:obterCombustivelResponse"] && xml["ns1:obterCombustivelResponse"]["return"] 
					? xml["ns1:obterCombustivelResponse"]["return"]["dados"]
					: [];
		return combustiveis 
	}	, 
	planos: async (token) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/icarros/planos`,{token}),
			xml = data && data.xml && data.xml.indexOf("obterTiposAnuncio")>0 ? parseXmlToJson(data.xml) : {},
			combustiveis= xml["ns1:obterTiposAnuncioResponse"] && xml["ns1:obterTiposAnuncioResponse"]["return"] 
					? xml["ns1:obterTiposAnuncioResponse"]["return"]["dados"]
					: [];
		console.log(xml)
		return combustiveis 
	}	
}
//----- INTEGRAÇÃO - AUTOLINE -----
export const autoline = {
	credenciais: async (email, senha) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/credenciais`,{email, senha}),
			xml = data && data.xml && data.xml.indexOf("credenciais")>0 ? parseXmlToJson(data.xml) : {},
			credenciais = xml["credenciais"] ? xml["credenciais"] : [];
		return credenciais
	},
	autenticar: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/autenticar`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			autenticar = xml["ConsultarCambiosResponse"]["ConsultarCambiosResult"]["LookupModel"] ? "Ok" : "Erro";
		return autenticar
	},
	marcas: async (segment) => {// segmento:["carro","moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/${segment}/marcas`,{}),
			xml = data && data.xml && data.xml.indexOf("MakeLookupModel")>0 ? parseXmlToJson(data.xml) : {},
			marcas= xml["ConsultarMarcasResponse"] && xml["ConsultarMarcasResponse"]["ConsultarMarcasResult"] 
					? xml["ConsultarMarcasResponse"]["ConsultarMarcasResult"]["MakeLookupModel"]
					: [];
		return marcas 
	},
	modelos: async (makeId) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/modelos`,{code:makeId}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			modelos = xml["ConsultarModelosResponse"] && xml["ConsultarModelosResponse"]["ConsultarModelosResult"] 
					 ? xml["ConsultarModelosResponse"]["ConsultarModelosResult"]["LookupModel"] 
					 : [];
		return modelos
	},
	anosmodelo: async (modelId) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/anosmodelo`,{code:modelId}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			anos= xml["ConsultarAnosModeloResponse"] && xml["ConsultarAnosModeloResponse"]["ConsultarAnosModeloResult"] 
				 ? xml["ConsultarAnosModeloResponse"]["ConsultarAnosModeloResult"]["LookupModel"]
				 : [];
		return anos
	},
	versoes: async (modelYearId) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/versoes`,{code:modelYearId}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			versoes= xml["ConsultarVersoesModeloResponse"] && xml["ConsultarVersoesModeloResponse"]["ConsultarVersoesModeloResult"] 
				 ? xml["ConsultarVersoesModeloResponse"]["ConsultarVersoesModeloResult"]["LookupModel"] 
				 : [];
		return versoes
	},
	cambios: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/cambios`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			cambios= xml["ConsultarCambiosResponse"] && xml["ConsultarCambiosResponse"]["ConsultarCambiosResult"] 
				 ? xml["ConsultarCambiosResponse"]["ConsultarCambiosResult"]["LookupModel"] 
				 : [];
		return cambios
	},
	opcionais: async (segment) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/${segment}/opcionais`,{}),
			xml = data && data.xml && data.xml.indexOf("FeatureLookupModel")>0 ? parseXmlToJson(data.xml) : {},
			opcionais= xml["ConsultarOpcionaisResponse"] && xml["ConsultarOpcionaisResponse"]["ConsultarOpcionaisResult"] 
				 ? xml["ConsultarOpcionaisResponse"]["ConsultarOpcionaisResult"]["FeatureLookupModel"] 
				 : [];
		
		return opcionais
	},
	portas: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/portas`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			portas= xml["ConsultarNroPortasResponse"] && xml["ConsultarNroPortasResponse"]["ConsultarNroPortasResult"] 
				 ? xml["ConsultarNroPortasResponse"]["ConsultarNroPortasResult"]["LookupModel"] 
				 : [];
		
		return portas
	},
	cores: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/cores`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			cores= xml["ConsultarCoresResponse"] && xml["ConsultarCoresResponse"]["ConsultarCoresResult"] 
				 ? xml["ConsultarCoresResponse"]["ConsultarCoresResult"]["ColorLookupModel"] 
				 : [];
				 
		return cores
	},
	combustiveis: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/combustiveis`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			combustiveis= xml["ConsultarCombustiveisResponse"] && xml["ConsultarCombustiveisResponse"]["ConsultarCombustiveisResult"] 
				 ? xml["ConsultarCombustiveisResponse"]["ConsultarCombustiveisResult"]["LookupModel"] 
				 : [];
				 
		return combustiveis
	},
	categorias: async (segment) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/${segment}/categorias`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			categorias= xml["ConsultarCategoriasResponse"] && xml["ConsultarCategoriasResponse"]["ConsultarCategoriasResult"] 
				 ? xml["ConsultarCategoriasResponse"]["ConsultarCategoriasResult"]["LookupModel"] 
				 : [];
				 
		return categorias
	},
	planos: async (segment) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/${segment}/planos`,{}),
			xml = data && data.xml && data.xml.indexOf("AvailableAdPlanModel")>0 ? parseXmlToJson(data.xml) : {},
			planos= xml["ConsultarPlanosAdquiridosResponse"] && xml["ConsultarPlanosAdquiridosResponse"]["ConsultarPlanosAdquiridosResult"] 
				 ? xml["ConsultarPlanosAdquiridosResponse"]["ConsultarPlanosAdquiridosResult"]["AvailableAdPlanModel"] 
				 : [];
				 
		return planos
	},
	ufs: async () => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/ufs`,{}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			ufs= xml["ConsultarUFsResponse"] && xml["ConsultarUFsResponse"]["ConsultarUFsResult"] 
				 ? xml["ConsultarUFsResponse"]["ConsultarUFsResult"]["LookupModel"] 
				 : [];
			 
		return ufs
	},
	cidades: async (ufId) => {
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/cidades`,{code:ufId}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			cidades = xml["ConsultarCidadesResponse"] && xml["ConsultarCidadesResponse"]["ConsultarCidadesResult"] 
				 ? xml["ConsultarCidadesResponse"]["ConsultarCidadesResult"]["LookupModel"] 
				 : [];
				 
		return cidades
	},
	motivos: async (ufId) => { //motivos para cancelamento
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/motivos`,{code:ufId}),
			xml = data && data.xml && data.xml.indexOf("LookupModel")>0 ? parseXmlToJson(data.xml) : {},
			motivos = xml["ConsultarMotivosCancelamentoAnuncioResponse"] && xml["ConsultarMotivosCancelamentoAnuncioResponse"]["ConsultarMotivosCancelamentoAnuncioResult"] 
				 ? xml["ConsultarMotivosCancelamentoAnuncioResponse"]["ConsultarMotivosCancelamentoAnuncioResult"]["LookupModel"] 
				 : [];
				 
		return motivos
	},
	getCidade: async (city,uf) => {
		const ufs =  await autoline.ufs()
		if(ufs.length){
			uf = ufs.filter(e => e.Name === uf)
			if(uf.length){
				city=semAcentos(city).toLowerCase().trim()
				const cidades =  await autoline.cidades(uf[0].Id),
					res = cidades.filter( e => semAcentos(e.Name.trim()).toLowerCase().indexOf(city)>-1 )
				
				if(res.length)
					return res[0]
			}
		}
		return null
	},
	getCombustivel: async (combustivel) => {
		//const color = {DisplayPriority: {}, Hex: "16777215", Id: "16", MaxYear: "0", MinYear: "0", Name: "Outra"}
		if(combustivel.trim().length){
			combustivel = semAcentos(combustivel).toLowerCase().trim().replace(/\//g,'')
			const combustiveis = await autoline.combustiveis(),
				res = combustiveis.filter(e => semAcentos(e.Name.replace(/\se\s|,\s/g,'')).toLowerCase().indexOf(combustivel)>-1);

			if(res.length===0)
				return null
			return res[0]
		}
		return null
	},
	getCor: async (cor) => {
		const color = {DisplayPriority: {}, Hex: "16777215", Id: "16", MaxYear: "0", MinYear: "0", Name: "Outra"}
		if(cor.trim().length){
			cor = semAcentos(cor).toLowerCase().trim()
			cor = cor.substr(0, cor.length-1)
			const cores = await autoline.cores(),
				res = cores.filter(e => semAcentos(e.Name).toLowerCase().indexOf(cor)>-1);

			if(res.length===0)
				return color
			return res[0]
		}
		return null
	},
	getPortas: async (nPortas) => {
		if(nPortas){
			const portas = await autoline.portas(),
				res =  portas.filter(e => e.Id.indexOf(nPortas)>-1);

			if(res.length===0)
				return null
			return res[0]
		}
		return null
	},
	getOpcionais: async (segment, bdpOpcionais) => {
		const opcionais = await autoline.opcionais(segment);
		let out = [],
			opcs= bdpOpcionais,
			res = [];
			
			opcs.filter(e => {
				let result = false
				const tx = e ? semAcentos(e).toLowerCase().trim() : ""
				tx.length && opcionais.every((o,i) => {
					if(semAcentos(o.Name).toLowerCase().indexOf(tx)>-1){
						res.push(opcionais.splice(i,1)[0])
						result = true
						return false
					}
					return true
				})
				if(!result) out.push(e)
				return result
			})
		//console.log(bdpOpcionais, res)
		return {res, out}
	},
	getCambio: async (txt) => {
		const cambios = await autoline.cambios(),
			tx = semAcentos(txt.replace("tico","tica")).trim().toLowerCase();
		let res = cambios.filter(c => semAcentos(c.Name).toLowerCase().indexOf(tx)>-1)
		//console.log(cambios)
		if(res.length>1){
			res.sort()
		}else if(res.length===0) res =[{DisplayPriority: {}, Id: "4", MaxYear: "0", MinYear: "0", Name: "Manual"}]
		return res[0]
	},
	getModeloVersao: async (tMarca, tModelo, tAno, tVersao) => {
		//DETERMINANDO A MARCA
		let result = {marca:{}, modelo:{}, versao:{}},
			marcas  = await autoline.marcas("carro"),
			marca   = filterArray(marcas,"Name", tMarca);
        if(marca.length===0){
			marca   = filterArray(marcas, "Name", tMarca.substr(0,3))
        }
        if(marca.length){
            if(marca.length===1) marca=marca[0]
            else{
                console.log("várias marcas selecionadas",tMarca, marcas)
            }

            if(marca["Id"]){ //DETERMINANDO O MODELO
				//console.log("Marca",  marca)
				result.marca = marca
                const modelos = await autoline.modelos(marca["Id"])
                if(modelos.length){ 
                    const model = tModelo.trim().split(" ")[0];
					let modelo= filterArray(modelos, "Name", model)

                    //console.log(modelo, model, modelos)
                    if(modelo.length===1) modelo=modelo[0]
                    else{
                        modelo = modelo.length ? filterArray(modelo, "Name", tModelo) : []
						
						//console.log(modelo,tModelo, modelos)
                        if(modelo.length===1) modelo=modelo[0]
                        else{
							modelo = modelo.length ? filterArray(modelos, "Name", tModelo, true) : []
							//console.log(modelo,tModelo, modelos)
                            if(modelo.length===1) modelo=modelo[0]
                            else{
								modelo= filterArray(modelos, "Name", model, true)
								if(modelo.length===1) modelo=modelo[0]
								else
                                	console.log("MODELO NÃO DETERMINADO", tModelo, modelos)
							}
                        }
                    }

                    if(modelo["Id"]){ //DETERMINANDO O ANO DO MODELO
						//console.log("MODELO", modelo)
						result.modelo = modelo
                        const anos = await autoline.anosmodelo(modelo["Id"])
						let ano = filterArray(anos, "Name", tAno, true)
						//anos.filter(a => a.Name===tAno)
                        
                        //console.log(anos)
                        if(ano.length){//DETERMINANDO A VERSÃO
                            ano  = ano[0]
                            const versoes = await autoline.versoes(ano["Id"])
                            
                            if(versoes.length>1){ 
                                const vrs = semAcentos(tModelo.trim()+' '+tVersao.trim()).toUpperCase().split(" "),
									cil = getCilindrada(tModelo+' '+tVersao),
									field =  "Name";
                                //console.log("Cilindrada",cil)
                                versoes.forEach(v => {
									let ttl = 0,
										name = semAcentos(v[field]);
                                    vrs.forEach(e => {
                                        if(name.indexOf(e)>-1 && name.indexOf(cil)>-1) ttl+=e.length
                                    })
                                    v["total"]=ttl
                                })
                                versoes.sort((a,b)=>{
                                    if(a.total>b.total){ return -1 }
                                    else if(a.total<b.total){ return 1 }
                                    else{
                                        if(a[field].length<b[field].length){return -1}
                                        else if(a[field].length>b[field].length){return 1}
                                        else return 0
                                    }
                                })
                                //console.log(versoes[0],versoes)
								result.versao = versoes[0]
                            }else{
								result.versao = versoes
								//console.log(versoes)
							}
                        }
                    }
                }
            }
		}else console.log("Nenhuma marca selecionadas", tMarca, marcas)
		return result
	},
	getAd: async (data, shop) => {
		let json = {},
			desc = data.desc.replace("</v","<v").split("<v>"),
			versao = (desc[1] ? desc[1] : "") + (data.cambio ? " "+data.cambio.substr(0,3) : ""),
			anos = data.ano.split("/").sort(),
			anomod = anos.pop();

		const modeloVersaoAL = await autoline.getModeloVersao(data.marca, desc[0], anomod, versao),
			cambio = await autoline.getCambio(data.cambio),
			acess = await autoline.getOpcionais(data.categoria, data.acess),
			portas = await autoline.getPortas(data.portas),
			cor = await autoline.getCor(data.cor),
			combustivel = await autoline.getCombustivel(data.combustivel),
			cityuf = data.cidade.split("/"),
			cidade = await autoline.getCidade(cityuf[0],cityuf[1]),
			//categoria = await autoline.categorias("carro"),
			motivos = await autoline.motivos(),
			plano = await autoline.planos("carro");

		let acessTag = [];

		if(acess.res.length){
			acess.res.forEach((e,i)=> {acessTag.push(e.Id*1)})
		}

		json["MakeId"]=modeloVersaoAL.marca.Id
		json["MakeName"]=modeloVersaoAL.marca.Name
		json["ModelId"]=modeloVersaoAL.modelo.Id
		json["ModelName"]=modeloVersaoAL.modelo.Name
		json["ModelVersionId"]=modeloVersaoAL.versao.Id
		json["ModelVersionName"]=modeloVersaoAL.versao.Name
		json["ModelYear"]=anomod
		json["BuiltYear"]=anos[0]
		json["ColorId"]=cor && cor.Id ? cor.Id : ''
		json["FuelTypeId"]=combustivel && combustivel.Id ? combustivel.Id : ''
		json["DoorNumberId"]=portas && portas.Id ? portas.Id : ''
		json["BodyTypeId"]=3
		json["RegistrationPlate"]=data.placa.replace(/-/g,'')
		json["Odometer"]=data.km.trim().replace(/\skm|\./gi,'')
		json["Price"]=data.preco
		json["IsArmored"]=data.neces.indexOf("Blindado")>-1
		json["IsOneOwnerUsed"]=data.docs.indexOf("Único dono")>-1
		json["IsSwapNotAccepted"]=true
		json["IsRegistrationPaid"]=false
		json["IsTaxPaid"]=data.docs.indexOf("IPVA pago")>-1
		json["AreAllServicesMadeByAuthorizedCenters"]=data.docs.indexOf("Todas revisões pela concessionária")>-1
		json["IsFinanced"]=false
		json["IsManufacturerWarrantyActive"]=data.docs.indexOf("Garantia de fábrica")>-1
		json["IsDisabilityAdapted"]=data.neces.indexOf("Adaptado para deficientes físicos")>-1
		json["IsCollectorVehicle"]=false
		json["IsZeroKm"]=data.zero
		json["AdditionalInformation"]=data.obs
		json["AdPlanSubscriptionId"]=plano.AdPlanSubscriptionId
		json["ZipCode"]=shop.end.cep.replace("-","")
		json["CityId"]=cidade.Id
		json["IsFeatured"]=false
		json["TransmissionId"]=cambio.Id
		json["TransmissionName"]=cambio.Name
		json["Features"] = JSON.stringify(acessTag)
		//json["RegistrationNumber"]=
		// json["ClientOriginId"]=
		// json["Adexpiration"]=

		return json
	},
	inserir: async (segment, xml) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/${segment}/inserir`,{xml}),
			xml1 = data && data.xml && data.xml.indexOf("IncluirAnuncioCarroResult")>0 ? parseXmlToJson(data.xml) : {},
			codigo= xml1["IncluirAnuncioCarroResponse"] && xml1["IncluirAnuncioCarroResponse"]["IncluirAnuncioCarroResult"] 
				 ? xml1["IncluirAnuncioCarroResponse"]["IncluirAnuncioCarroResult"]
				 : [];
				 
		return codigo
	},
	excluir: async (code, reason) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/excluir`,{code, reason}),
			xml = data && data.xml && data.xml.indexOf("CancelarAnuncioResult")>0 ? parseXmlToJson(data.xml) : {},
			status= xml["CancelarAnuncioResponse"] && xml["CancelarAnuncioResponse"]["CancelarAnuncioResult"] 
				 ? xml["CancelarAnuncioResponse"]["CancelarAnuncioResult"]
				 : "erro";
				 
		return status
	},
	inserirFoto: async (code, base64) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/fotos-inserir`,{code,fotos:base64}),
			xml1 = data && data.xml && data.xml.indexOf("InserirFotosResult")>0 ? parseXmlToJson(data.xml) : {},
			status= xml1["InserirFotosResponse"] && xml1["InserirFotosResponse"]["InserirFotosResult"] 
				 ? xml1["InserirFotosResponse"]["InserirFotosResult"]
				 : "erro";
				 
		return status
	},
	excluirFoto: async (code, foto) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/foto-excluir`,{code, foto}),
			xml1 = data && data.xml && data.xml.indexOf("ExcluirFotoResult")>0 ? parseXmlToJson(data.xml) : {},
			status= xml1["ExcluirFotoResponse"] && xml1["ExcluirFotoResponse"]["ExcluirFotoResult"] 
				 ? xml1["ExcluirFotoResponse"]["ExcluirFotoResult"]
				 : "erro";
				 
		return status
	},
	consultarFotos: async (code) => { //["carro", "moto"]
		const {data} = await Axios.post(`${myServer}/integrador/autoline/todos/fotos-consultar`,{code}),
			xml1 = data && data.xml && data.xml.indexOf("ConsultarFotosResult")>0 ? parseXmlToJson(data.xml) : {},
			imgs= xml1["ConsultarFotosResponse"] && xml1["ConsultarFotosResponse"]["ConsultarFotosResult"] 
				 ? xml1["ConsultarFotosResponse"]["ConsultarFotosResult"]["AdImageInfo"]
				 : [];
				 
		return imgs
	}
}
//----- FIM - AUTOLINE -----